<div class="login-page">
  <div class="login-container">

  <!-- Forgot Password Left Side Section Code Start -->      
    <div class="login-form-container forgot-password-container" role="main">
      <div class="logo"><img src="assets/images/logo.svg" alt="Logo" /></div>
      <h1 class="heading-level-4 gray-color mt-40 mb-20">Forgot Your Password?</h1>
      <p class="forgot-label">
        Username: <b>{{email}}</b> If you have an account, reset instructions will be sent to your email address.
          <a href="javascript:void(0)" (click)="Login()"> Click here to return to homepage.</a>
      </p>

      <div class="login-bottom-section pt-90" aria-label="contentinfo">
        <img src="assets/images/ABA-logo.png" alt="ABA Logo" aria-label="Footer Logo"/>
        <p>© {{ currentYearCopyRight }} American Bankers Association</p>        
      </div>

  </div>
  <!-- Forgot Password Left Side Section Code Start -->      

  <!-- Forgot Password Right Side Image Section Code Start -->      
  <div class="login-image-container" role="banner">
      <img src="assets/images/fp-banner.png" alt="Forgot Password" />
  </div>
  <!-- Forgot Password Right Side Image Section Code End -->      

</div>
</div>

